function addToCartAjx(uid) {
  console.log('addToCartAjx LOADED');
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send('quantity=1&id=' + uid);
  xhr.onload = function() {
    if (xhr.status === 200 && xhr.readyState === 4 ) {
      console.log('success');
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } else {
      console.log('error');
    }
  };
  xhr.onerror = function() {
    console.log('error');
  };
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function(e) {
  const target = e.target.closest('.ProductItem__addToCart');
  if (!target) return;

  e.preventDefault();
  target.classList.add('active');
  target.querySelector('.trans').textContent = 'Ajout...';
  const t = target.dataset.vid;
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.onload = function() {
    if (xhr.status === 200 && xhr.readyState === 4 ) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      console.log('success');
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('cart:open'));
        target.classList.add('submited');
        target.querySelector('.trans').textContent = 'Ajouté !';
        setTimeout(function() {
          target.querySelector('.trans').textContent = 'Ajouter';
          target.classList.remove('active', 'submited');
        }, 1500);
      }, 1500);
    } else {
      console.log('error');
    }
  };
  xhr.onerror = function() {
    console.log('error');
  };
  xhr.send('quantity=1&id=' + t);
});
});

/**/
document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.querySelector('.btn--add-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function(event) {
      event.preventDefault();

      const t = this.dataset.uid;
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send('quantity=1&id=' + t);
      xhr.onload = function() {
        if (xhr.status === 200 && xhr.readyState === 4) {
          console.log('succès');
          document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem'));
        } else {
          console.log('erreur');
        }
      };
      xhr.onerror = function() {
        console.log('erreur');
      };
    });
  } else {
    console.log("Le bouton '.btn--add-to-cart' n'a pas été trouvé.");
  }
});

/* Scroll and hide summary blog */
document.addEventListener('DOMContentLoaded', function() {

  $(document).on('click', '.articleSummary__item', function() {
    var eq = $(this).index();
    $('html, body').animate({
        scrollTop: $('.articleBody__inner .rte h2').eq(eq).offset().top - 260
    }, 800);
  });


  if (window.matchMedia("(max-width: 800px)").matches) {
    $(document).on('click', '.articleSummary__Title', function() {
        $('.articleSummary').slideToggle();
        $('.articleSummary__Title').toggleClass('open');
    });
  }
});

/* Obfuscation de lien */
document.addEventListener('DOMContentLoaded', function() {
  $(document).on('click','.mk-link',function() {
    var attribute = $(this).attr('data-mk');
    if(attribute != undefined) {
      if (window.event.ctrlKey) {
        var newWindow = window.open(decodeURIComponent(attribute), '_blank');
        newWindow.focus();
      } else {
        var target = $(this).attr('target');
        if(target == '_blank') {
          var newWindow = window.open(decodeURIComponent(attribute), '_blank');
          newWindow.focus();
        } else {
          document.location.href = decodeURIComponent(attribute);
        }
      }
    }
  });
});

/* ScrollBar */
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener(
    "scroll",
    function() {
        var scrollTop = document.documentElement["scrollTop"] || document.body["scrollTop"];
        var scrollBottom = (document.documentElement["scrollHeight"] || document.body["scrollHeight"]) - document.documentElement.clientHeight;
        scrollPercent = scrollTop / scrollBottom * 100 + "%";
        var progressBar = document.getElementById("progress-bar");
        if (progressBar) {
            progressBar.style.setProperty("--scroll", scrollPercent);
        }
        if (scrollTop == 0) {
            document.querySelector('.site-header').classList.remove('scrolling');
        } else {
            document.querySelector('.site-header').classList.add('scrolling');
        }
    },
    { passive: true }
  );
});

/* Bar à charms */

function addEventListeners(elements, event, handler) {
  elements.forEach(element => element.addEventListener(event, handler));
}
function closeStepContent(id) {
  document.querySelector('[data-step="'+ id + '"]').style.display = 'none';
  document.querySelector('[data-step="'+ id + '"] .collapsible-trigger').click();
}
function showStepContent(id) {
  document.querySelector('[data-step="'+ id + '"]').style.display = 'block';
  document.querySelector('[data-step="'+ id + '"] .collapsible-trigger').click();
}
function changeActiveStep(id) {
  document.querySelector('.step_active').classList.remove('step_active');
  document.querySelector('[data-step="'+ id + '"]').classList.add('step_active');
}

function changeSubmitLabel() {
  const newLabelNextButton = document.querySelector('.charms-bar__buttons .submit-button').getAttribute('data-alternate');
  const oldLabelNextButton = document.querySelector('.charms-bar__buttons .submit-button').textContent.split(' | ')[0];
  document.querySelector('.charms-bar__buttons .submit-button').textContent = newLabelNextButton;
  document.querySelector('.charms-bar__buttons .submit-button').dataset.alternate = oldLabelNextButton;
}

/* Mise à jour du récapitulatif */
function updateCartSummary() {
  const cartItems = document.querySelector('.cart-items-recap');
  cartItems.innerHTML = '';

  document.querySelectorAll('.selectable-product.selected').forEach(product => {
    const clonedProduct = product.parentElement.cloneNode(true);
    clonedProduct.style.display = 'block';
    clonedProduct.querySelectorAll('.selectable-product.selected').forEach(selected => selected.classList.remove('selected'));
    cartItems.appendChild(clonedProduct);
  });
}

/* Calcul du prix total */
function calculateTotal() {
  const selectedProducts = document.querySelectorAll('.selectable-product.selected');

  let total = 0;

  document.querySelectorAll('.support-content .js-qty__num').forEach(qty => {
    qty.value = 1;
  });

  selectedProducts.forEach(product => {
    const quantity = product.querySelector('.js-qty__num');
    if (quantity) {
      const qty = parseInt(quantity.value, 10);
      const price = parseFloat(product.getAttribute('data-price'));
      console.log('price = ' + price);
      total += qty * price;
    }
  });


  const newLabelNextButton = document.querySelector('.charms-bar__buttons .submit-button').getAttribute('data-alternate');
  const oldLabelNextButton = document.querySelector('.charms-bar__buttons .submit-button').textContent;
  document.querySelector('.charms-bar__buttons .submit-button').dataset.alternate = oldLabelNextButton;
  console.log('total = ' + total);
  console.log('total2 = ' + total.toFixed(2));
  document.querySelector('.charms-bar__buttons .submit-button').textContent = newLabelNextButton + ' | ' + total.toFixed(2).replace('.00', '') + '€';
}

function clickImageForChoose(event) {
  const clickedImage = event.target;
  var isSelected = clickedImage.classList.contains('selected');
  const activeStep = parseInt(clickedImage.closest('[data-step]').getAttribute('data-step'), 10);

  /* STEPS :
  1: Package
  2: Type of Package
  3: Choose Charms
  4 : Recap
   */
  switch (activeStep) {
    case 1:
      document.querySelectorAll('[data-step="1"] img').forEach((image) => {
        image.classList.remove('selected');
        image.parentElement.classList.remove('selected');
      });

      if (isSelected) {
        clickedImage.classList.remove('selected');
        clickedImage.parentElement.classList.remove('selected');
      } else {
        clickedImage.classList.add('selected');
        clickedImage.parentElement.classList.add('selected');
      }
      break;

    case 2:
      const product = clickedImage.closest('.selectable-product');
      charmLimit = parseInt(product.getAttribute('data-limit'), 10);

      if (!isSelected) {
        document.querySelectorAll('[data-step="2"] .selectable-product').forEach(prod => prod.classList.remove('selected'));
      }

      if (product.getAttribute('data-available') === 'true') {
        if (isSelected) {
          product.classList.remove('selected');
        } else {
          product.classList.add('selected');
        }
      } else {
        product.classList.remove('selected');
      }

      updateCartSummary();
      break;

    case 3:
      console.log("ETAPE SELECTION CHARM");
      const charm = clickedImage.closest('.selectable-product');
      const quantityInput = charm.querySelector('.js-qty__num');

      // Gérer la quantité et la sélection des charms disponibles
      if (charm.getAttribute('data-available') === 'true') {
        charm.classList.add('available');

        let newQuantity;

        // Vérifier la quantité totale sélectionnée avant de permettre des ajouts
        let currentSelectedCharms = document.querySelectorAll('.charms-content .selectable-product.selected');
        currentTotalQuantity = Array.from(currentSelectedCharms).reduce((sum, product) => {
          const qtyInput = product.querySelector('.js-qty__num');
          return sum + (qtyInput ? parseInt(qtyInput.value) : 0);
        }, 0);

        // ADD QUANTITY
        if (event.target.tagName === 'IMG' || event.target.closest('.js-qty__adjust__charms--plus')) {
          if (limitExist && currentTotalQuantity >= charmLimit) {
            const warning = document.querySelector('.warning_limit');
            warning.style.opacity = 1;
            return; // Ne pas ajouter si la limite est atteinte
          }

          // CLASS FOR SELECTED CHARM
          if (!charm.classList.contains('selected')) {
            charm.classList.add('selected');
          }

          // INCREASE QUANTITY
          newQuantity = parseInt(quantityInput.value) + 1;
          quantityInput.value = newQuantity;

          // Gestion de la limite
          if (limitExist && currentTotalQuantity >= charmLimit - 1) {
            document.querySelector('.charms-bar__buttons .submit-button').disabled = false;
            document.querySelectorAll('.charms-content .js-qty__adjust__charms--plus').forEach(button => {
              button.setAttribute('disabled', 'true');
            });
            const warning = document.querySelector('.warning_limit');
            warning.style.opacity = 1;
          } else {
            document.querySelectorAll('.charms-content .js-qty__adjust__charms--plus').forEach(button => {
              button.removeAttribute('disabled');
            });
            document.querySelector('.warning_limit').style.opacity = 0;
          }
        } 
        // REMOVE QUANTITY
        else if (event.target.closest('.js-qty__adjust__charms--minus') && quantityInput.value - 1 >= 0) {
          newQuantity = parseInt(quantityInput.value) - 1;
          quantityInput.value = newQuantity;

          // Si la quantité tombe à 0, retirer le produit de la sélection
          if (parseInt(quantityInput.value) <= 0) {
            charm.classList.remove('selected');
          }

          // Mise à jour du total de quantités sélectionnées après réduction
          currentTotalQuantity = Array.from(document.querySelectorAll('.charms-content .selectable-product.selected'))
            .reduce((sum, product) => {
              const qtyInput = product.querySelector('.js-qty__num');
              return sum - (qtyInput ? parseInt(qtyInput.value) : 0);
            }, 0);

          // Réactiver les boutons "plus" si on est en dessous de la limite
          if (currentTotalQuantity < charmLimit) {
            document.querySelector('.charms-bar__buttons .submit-button').disabled = true;
            document.querySelectorAll('.charms-content .js-qty__adjust__charms--plus').forEach(button => {
              button.removeAttribute('disabled');
            });
            document.querySelector('.warning_limit').style.opacity = 0;
          }
        }
      } else {
        charm.classList.remove('available');
        charm.classList.add('unavailable');
      }

      updateCartSummary();

      break;

    case 4:
      break;

    default:
      return 'Invalid option';
  }
}



document.addEventListener('DOMContentLoaded', function() {
  let previousStep = 'type'; // Initial step
  let packageType = 'none';  // Variable globale pour sauvegarder le packageType
  // BEGIN GUILLAUME CODE

  addEventListeners(document.querySelectorAll('.charms-bar__step img, [data-step="3"] .js-qty__adjust__charms'), 'click', clickImageForChoose);
  
  document.querySelectorAll('[data-step="1"] .image-wrapper').forEach(image => {
    image.addEventListener('click', () => {
      // Vérifie si l'image est sélectionnée avant de simuler le clic sur le bouton valider
      if (image.classList.contains('selected')) {
        // Simule le clic sur le bouton valider
        document.querySelector('.charms-bar__buttons .submit-button').click();
      }
    });
  });
  
  document.querySelector('.charms-bar__buttons').addEventListener('click', (event) => {

    var activeStep = parseInt(document.querySelector('.step_active').getAttribute('data-step'));
    const clickedButton = event.target;
    const isBackButton = clickedButton.classList.contains('previous-button');
    
    if (isBackButton) {
      // Gestion du bouton retour
      switch (activeStep) {
        case 1:
          break;

        case 2:
          document.querySelector('.charms-bar__buttons .previous-button').style.display = 'none';
          
          document.querySelectorAll('[data-step="2"] .selectable-product').forEach(product => {
            product.classList.remove('selected');
          });

          closeStepContent(2);
          showStepContent(1);
          changeActiveStep(1);
          break;

        case 3:
          document.querySelector('.charms-bar__buttons .submit-button').disabled = false;

          document.querySelectorAll('[data-step="3"] .js-qty__num').forEach(qty => {
            qty.value = 0;
          });
          document.querySelectorAll('[data-step="3"] .selectable-product').forEach(product => {
            product.classList.remove('selected');
          });
          document.querySelectorAll('.charms-filters .filter').forEach(filter => {
            filter.classList.remove('selected');
          });

          if (packageType === 'none') {
            closeStepContent(3);
            showStepContent(1);
            changeActiveStep(1);
          } else {
            closeStepContent(3);
            showStepContent(2);
            changeActiveStep(2);
          }

          break;

        case 4:
          changeSubmitLabel();

          closeStepContent(4);
          showStepContent(3);
          changeActiveStep(3);

          break;

        default:
          return 'NO ACTIVE STEP';
      }
    } else {
      // Gestion du bouton suivant
      switch (activeStep) {
        case 1:
          const selectedImage = document.querySelector('[data-step="1"] .selectable-image.selected');
          if (selectedImage) {
            document.querySelector('.charms-bar__buttons .previous-button').style.display = 'block';
            packageType = selectedImage.closest('[data-type]').getAttribute('data-type');
          } else {
            break;
          }

          const bracelets = document.querySelector('.charms-bar_support .bracelets_list');
          const box = document.querySelector('.charms-bar_support .box_list');
          previousStep = 'type'; // Utilisateur vient de l'étape type

          switch (packageType) {
            case 'bracelet':
              limitExist = false;
              bracelets.style.display = 'flex';
              box.style.display = 'none';
              closeStepContent(1);
              showStepContent(2);
              changeActiveStep(2);

              break;

            case 'box':
              limitExist = true;
              bracelets.style.display = 'none';
              box.style.display = 'flex';
              closeStepContent(1);
              showStepContent(2);
              changeActiveStep(2);
              break;

            case 'none':
              limitExist = false;
              closeStepContent(1);
              showStepContent(3);
              changeActiveStep(3);
              break;

            default:
              return 'NO PACKAGE TYPE';
          }
          break;

        case 2:
          if(limitExist) {
            document.querySelector('.charms-bar__buttons .submit-button').disabled = true;
          }

          closeStepContent(2);
          showStepContent(3);
          changeActiveStep(3);
          previousStep = 'support'; // Utilisateur vient de l'étape support
          break;

        case 3:
          updateCartSummary();
          calculateTotal();

          document.querySelectorAll('.charms-filters .filter').forEach(filter => {
            filter.classList.remove('selected');
          });
          closeStepContent(3);
          showStepContent(4);
          changeActiveStep(4);

          break;

        case 4:
          const selectedProduct = document.querySelector('.support-content .selectable-product.selected');
          const selectedCharms = document.querySelectorAll('.charms-content .selectable-product.selected');
          const items = [];

          if (selectedProduct) {
            const productId = selectedProduct.getAttribute('data-uid');
            if (productId) {
              items.push({ quantity: 1, id: productId });
            }
          }

          selectedCharms.forEach(charm => {
            const charmId = charm.getAttribute('data-uid');
            const quantity = charm.querySelector('.js-qty__num').value;
            if (charmId) {
              items.push({ quantity: quantity, id: charmId });
            }
          });

          const formData = { items };

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          })
            .then(response => {
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));

              return response.json();
            })
            .catch(error => console.error('Error:', error));

        default:
          return 'NO ACTIVE STEP';
      }
    }
  });


  // END GUILLAUME CODE
  
  /* Filtrer les produits par couleur */
  function filterProducts(color) {
    document.querySelectorAll('.charms-bar_charms .charm-item').forEach(product => {
      product.style.display = product.getAttribute('data-color') === color ? 'block' : 'none';
    });
  }
  
  /* Afficher tous les produits */
  function showAllProducts() {
    document.querySelectorAll('.charms-bar_charms .charm-item').forEach(product => product.style.display = 'block');
  }
  
  /* Gestion des événements de filtre */
  function handleFilterClick(filter, color) {
    const filters = [silverFilter, goldFilter, roseGoldFilter];

    if (filter.classList.contains('selected')) {
      filter.classList.remove('selected');
      showAllProducts();
    } else {
      filters.forEach(f => f.classList.remove('selected'));
      filter.classList.add('selected');
      filterProducts(color);
    }
  }

  document.querySelectorAll('.charms-bar_support .selectable-product').forEach(product => {
    const isAvailable = product.getAttribute('data-available') === 'true';
    
    if (isAvailable) {
      product.classList.add('available');
      product.classList.remove('unavailable');
    } else {
      product.classList.add('unavailable');
      product.classList.remove('available');
    }
  });

  const silverFilter = document.querySelector('.silver-filter');
  const goldFilter = document.querySelector('.gold-filter');
  const roseGoldFilter = document.querySelector('.pink-gold-filter');
  silverFilter.addEventListener('click', () => handleFilterClick(silverFilter, 'Argenté'));
  goldFilter.addEventListener('click', () => handleFilterClick(goldFilter, 'Doré'));
  roseGoldFilter.addEventListener('click', () => handleFilterClick(roseGoldFilter, 'Or rose'));
});